import React from 'react';
import { DetectEnvironment } from '../../../EnvironmentSettings';

const SendEmailText = (props) => {
    return (
        <div className="row" >
            <div className="col-lg-9">
                <img className="welcome-page-logo" src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="logo" />
                <div className='send-mail-text'>
                    {/* An email has been sent to you gmail account, please click on the link to verify your identity. */}
                    Thank you for signing up with us. Please check your email, as we have sent you an email confirmation request to proceed with your account.
                </div>
            </div>
            <div className="right-bar welcome-right-bar col-lg-3" >
                <div>
                </div>
            </div>
        </div>
    )
}
export default SendEmailText;